import { FormattedMessage, useIntl } from 'react-intl';
import { useController } from 'react-hook-form';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {
  Box,
  FormControl,
  FormLabel,
  FormErrorMessage,
} from '@chakra-ui/react';

export const REACT_QUILL_EMPTY_STRING = '<p><br></p>';

export const ReactQuillEditor = ({ control, name, label, placeholder }) => {
  const intl = useIntl();

  const {
    field,
    fieldState: { error },
  } = useController({ control, name });

  return (
    <Box my={2} py={1}>
      <FormControl isInvalid={!!error}>
        <FormLabel fontSize="lg" fontWeight="bold" htmlFor={name}>
          <FormattedMessage {...label} />
        </FormLabel>
        <Box maxW="3xl">
          <ReactQuill
            theme="snow"
            placeholder={intl.formatMessage(placeholder)}
            {...field}
          />
        </Box>
        {!!error && <FormErrorMessage>{error.message}</FormErrorMessage>}
      </FormControl>
    </Box>
  );
};
